<div class="div-password">
  <div [formGroup]="passwordFormGroup">
    <div class="passwordInfo">
      <mat-form-field *ngIf="showOldPassword" [floatLabel]="'always'">
        <input matInput class="oldPasswordValidate" [type]="hide ? 'password' : 'text'" formControlName="oldPassword" pattern="[^' ']+"
          placeholder="OLD PASSWORD">
        <mat-icon matSuffix (click)="hide = !hide" fontIcon="visibility_off" class="dd-red">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
      <div formGroupName="newPasswordGroup">
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="passwordValidate" [type]="hide ? 'password' : 'text'" formControlName="newPassword" pattern="[^' ']+"
            placeholder="PASSWORD"  (input)="checkPasswordStatus()">
          <mat-icon matSuffix (click)="hide = !hide" fontIcon="visibility" class="dd-red">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>        
        </mat-form-field>
        <mat-form-field *ngIf="showConfirmPassword" [floatLabel]="'always'">
          <input matInput class="confirmPasswordValidate" [type]="hideConfirm ? 'password' : 'text'" pattern="[^' ']+"
            formControlName="confirmPassword" placeholder="CONFIRM PASSWORD" (input)="confirmNewPassword()">
          <mat-icon matSuffix (click)="hideConfirm = !hideConfirm" class="dd-red">
            {{hideConfirm ? 'visibility_off' : 'visibility'}}
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="col-md-12 error-msg">
          <span [class.green-color]="passwordStatus?.lengthMatch">
            Password should be between 8 and 20 characters in length <br>
          </span>
          <span [class.green-color]="passwordStatus?.passwordMatchThreeTypes">
            Must contain at least 3 of the following character types <br>
          </span>
          <ul>
            <li [class.green-color]="passwordStatus?.hasLower === 1">
                lower case letters
            </li>
            <li  [class.green-color]="passwordStatus?.hasUpper === 1">
                upper case letters
            </li>
            <li  [class.green-color]="passwordStatus?.hasNumbers === 1">
                numeric digits
            </li>
            <li  [class.green-color]="passwordStatus?.hasSpecial === 1">
                special characters (eq:!@#$%^&*)
            </li>
          </ul>
      </div>
    </div>
  </div>
</div>
